<template>
  <card-component title="Claim Portal" icon="lock" :has-card-header-background="true" :has-button-slot="true">
    <form @submit.prevent="submit" method="POST">
      <b-field label="RUT" >
        <b-input v-model="dni" name="dni" validation-message="No es un Rut válido"
              pattern="[0-9]*-[0-9a-zA-Z]" required autofocus/>
      </b-field>
      <hr>
      <div class="control">
        <b-button native-type="submit" class="button is-primary" expanded :class="{'is-loading':isLoadingStartClaim}">
          Activar Cuenta
        </b-button>
      </div>
    </form>
  </card-component>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import TokenRepository from '@/services/TokenRepository'
import ValidDNIRepository from '@/services/ValidDNIRepository'

export default {
  name: 'StartClaim',
  components: { CardComponent },
  data () {
    return {
      isLoadingStartClaim: false,
      isLoadingChangePassword: false,
      dni: null
    }
  },
  mounted () {
    this.$buefy.dialog.alert('A unos pasos de poder tener tu cuenta en Workplace:<br> 1.- Coloca tu Rut completo con dígito verificador de esta forma: 12300800-4, y dale a Activar Cuenta.<br> 2.- Responde la pregunta y dale <b>“Enviar Respuesta”</b>.<br> 3.- Listo ya estás en Workplace.<br><br> Si tienes correo electrónico entra directamente a la app de workplace')
  },
  methods: {
    submit () {
      this.isLoadingStartClaim = true
      setTimeout(() => {
        this.isLoading = false
        this.$store.dispatch('startClaim', this.dni
        ).then(result => {
          this.$router.push('/answer-questions')
        }).catch((error) => {
          this.isLoadingStartClaim = false
          this.showErrorToast(error)
        })
      }, 750)
    },
    changePassword () {
      if (this.dni) {
        this.isLoadingChangePassword = true
        ValidDNIRepository.changePassword(this.dni)
          .then((r) => {
            this.requestToken(r.data.user_id, r.data)
          }).catch(e => {
            this.isLoadingChangePassword = false
            this.showErrorToast(e)
          })
      }
    },
    showErrorToast (error) {
      let type = 'is-danger'
      let message = 'RUT invalido'
      if (error.response.status === 400) {
        type = 'is-info'
        message = error.response.data.detail
      }
      this.$buefy.toast.open({
        message: message,
        type: type
      })
    },
    requestToken (id, data) {
      TokenRepository.requestTokenSMS(id, data)
        .then((r) => {
          this.isLoadingChangePassword = false
          this.promptToken(id, data.phone_number)
        }).catch(e => {
          this.isLoadingChangePassword = false
          this.$buefy.toast.open({
            message: `Error: ${e.response.data.detail}`,
            type: 'is-danger'
          })
        })
    },
    getTokenSMS (token) {
      return {
        token_sms: token
      }
    },
    promptToken (idUser, phoneNumber) {
      this.$buefy.dialog.prompt({
        message: 'Escribe el código enviado al número ' + phoneNumber,
        inputAttrs: {
          type: 'text'
        },
        confirmText: 'Enviar Código',
        cancelText: 'Cancelar',
        trapFocus: true,
        closeOnConfirm: false,
        canCancel: ['escape', 'button'],
        onConfirm: (value, { close }) => {
          this.isLoading = true
          this.$buefy.toast.open('Validando código ...')
          TokenRepository.claimWorkplaceURL(idUser, this.getTokenSMS(value))
            .then((r) => {
              this.$store.commit('removeIDUser')
              window.location.replace(r.data.url_to_claim)
            }).catch(e => {
              this.isLoading = false
              this.$buefy.toast.open({
                message: `Error: ${e.response.data.detail}`,
                type: 'is-danger'
              })
            })
        },
        onCancel: () => {
          this.phoneNumber = null
        }
      })
    }
  }
}
</script>
